<div class="footer">
    <div class="footer__info" *ngIf="isRendered">
        <p *ngIf="details.title  && production(); else noTitle" class="footer__title">{{ details.title }}</p>
        <ng-template #noTitle><span *ngIf="restaurant?.title as title" class="footer__title">{{ title }}</span></ng-template>
        <p class="footer__details" *ngIf="production()">
            <span *ngIf="details.inn">ИНН: {{ details.inn }}</span>
            <span *ngIf="details.inn && (details.kpp || details.ogrn)" class="separator"> | </span>
            <span *ngIf="details.kpp">КПП: {{ details.kpp }}</span>
            <span *ngIf="details.kpp && details.ogrn" class="separator"> | </span>
            <span *ngIf="details.ogrn">ОГРН: {{ details.ogrn }}</span>
        </p>
        <span *ngIf="details && production()" class="footer__сontacts" (click)="onContactsClicked(); $event.stopPropagation()">{{ 'сontacts' | translate }}</span>
        
        <div class="footer__policy">
            <div class="checkbox" [class.checked]="agreement" (click)="toggleAgreement()">
                <svg *ngIf="agreement" width="12" height="12" viewBox="0 0 12 12" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 6L5 9L10 3" stroke="#28a745" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </div>
            <span class="policy-text">{{ 'iReadAndAgree' | translate }}</span>
            <!-- <a href="https://edim.online/info/policy/" class="footer-link" target="_blank"
                rel="noopener noreferrer">политики конфиденциальности</a>
            <span class="policy-text">и</span> -->
            <a [href]="policyUrl" class="footer-link" target="_blank"
                rel="noopener noreferrer">{{ 'privacyPolicyLink' | translate }}</a>
        </div>
    </div>
</div>
